import { DirectionsService } from "@react-google-maps/api";
import PropTypes from "prop-types";

export function MiDirectionsService({
  callback = () => null,
  destination = {},
  origin = {},
  travelMode = "DRIVING",
  waypoints = [],
}) {
  return (
    <DirectionsService
      options={{
        origin,
        waypoints,
        destination,
        travelMode,
      }}
      callback={callback}
    />
  );
}

MiDirectionsService.propTypes = {
  origin: PropTypes.object,
  waypoints: PropTypes.array,
  destination: PropTypes.object,
  travelMode: PropTypes.string,
  callback: PropTypes.func,
};
